import {
  useDeleteObjective,
  useObjective,
  useOptions,
  useOptionValues,
  usePeople,
  useUpsertObjective,
  useUserInfo,
} from '@/hooks';
import { isAuthorised } from '@/utils';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ObjectiveForm } from './ObjectiveForm';

export function Objective() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    query: { data: objective },
  } = useObjective(id);
  const { mutate: upsertObjective } = useUpsertObjective();
  const { mutate: deleteObjective } = useDeleteObjective();
  const {
    query: { data: people },
  } = usePeople();
  const {
    query: { data: userInfo },
  } = useUserInfo();
  const canEdit = isAuthorised(userInfo?.authorisation, 'objectives', true);
  const emailAddresses = useMemo(
    () =>
      [...new Set(people.map((item) => item.emailAddress).filter(Boolean))]
        .sort()
        .map((item) => ({ label: item, value: item })),
    [people],
  );
  const {
    query: { data: activeDirectoryGroups },
  } = useOptions('activeDirectoryGroup');
  const {
    query: { data: objectiveAttributes },
  } = useOptions('objectiveAttribute');
  const typeOptions = useOptionValues('groupType');

  function handleDelete(id) {
    deleteObjective(id, {
      onSuccess: () => {
        navigate('..', { replace: true });
      },
    });
  }

  function handleSubmit(values) {
    upsertObjective(values, {
      onSuccess: (data) => {
        navigate(`../${data.identifier}`, { replace: true });
      },
    });
  }

  return (
    <Box sx={{ flexGrow: 1, p: 1 }}>
      <title>
        {[
          'IR3',
          'Objectives',
          objective?._id ? objective.title : 'New Objective',
        ]
          .filter(Boolean)
          .join(' | ')}
      </title>
      <ObjectiveForm
        key={[objective?._id, objective?.lastEdit?.time]}
        defaultValues={objective}
        canEdit={canEdit}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        objectiveAttributes={objectiveAttributes}
        emailAddresses={emailAddresses}
        activeDirectoryGroups={activeDirectoryGroups}
        typeOptions={typeOptions}
      />
    </Box>
  );
}
